import Icon from '../../components/Icon.vue'

Icon.register({"regular/frown":{"width":496,"height":512,"paths":[{"d":"M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 456C137.7 456 48 366.3 48 256S137.7 56 248 56 448 145.7 448 256 358.3 456 248 456zM168 240C185.7 240 200 225.7 200 208S185.7 176 168 176 136 190.3 136 208 150.3 240 168 240zM328 176C310.3 176 296 190.3 296 208S310.3 240 328 240 360 225.7 360 208 345.7 176 328 176zM248 304C207.8 304 170 321.7 144.2 352.6 135.7 362.8 137.1 377.9 147.3 386.4 157.5 394.9 172.6 393.5 181.1 383.3 197.7 363.4 222.1 351.9 248 351.9S298.3 363.3 314.9 383.3C319.7 389 326.5 391.9 333.4 391.9 338.8 391.9 344.3 390.1 348.8 386.3 359 377.8 360.3 362.7 351.9 352.5 326 321.7 288.2 304 248 304z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/regular/frown.js
// module id = null
// module chunks = 